const NS = 'SiteHeaderBottomSubMenuItemsWidget';
const CLS = 'siteHeaderBottomSubMenuItemsWidget';

export class SiteHeaderBottomSubMenuItemsWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$dropdownHeadings = this.$element.children(`.${CLS}-dropdown`).children(`.${CLS}-dropdown-heading`);
		this.$selectedItem = null;
		this.itemContentAnimationDuration = 350;
		this.itemHeadingIconAnimationDuration = 250;
		this.itemHeadingIconRotationDegree = 90;

		this.$dropdownHeadings.on('click', (event) => {
			let $itemToBeSelected = $(event.currentTarget).parent(`.${CLS}-dropdown`);

			if(!this.$selectedItem) {
				this.activate($itemToBeSelected);
			}
			else if(this.$selectedItem[0].isEqualNode($itemToBeSelected[0]) && this.$selectedItem.attr('data-active')) {
				this.deactivate($itemToBeSelected);
			}
			else if(!this.$selectedItem[0].isEqualNode($itemToBeSelected[0])) {
				this.deactivate(this.$selectedItem);
				this.activate($itemToBeSelected);
			}
		});

		// Deactivates all the dropdowns. for the most part can be called by the parent dropdown…
		this.$element.on(`${CLS}.dropdown.deactivate`, (event) => {
			event.stopPropagation();
			if(this.$selectedItem) {
				this.deactivate(this.$selectedItem);
			}
		});

		this.$element.on(`${CLS}.dropdown.activate`, (event, params) => {
			event.stopPropagation();
			// Dropdown element passed from sidebarWidget
			if(params.element) {
				this.activate(params.element, params.animate);
			}
		});
	}

	activate(item, animate = true) {
		if(animate) {
			item.children(`.${CLS}-dropdown-content`).slideDown({
				duration: this.itemContentAnimationDuration
			});
			this.rotateIcon(item, 0, this.itemHeadingIconRotationDegree);
		}
		else {
			item.children(`.${CLS}-dropdown-content`).show();
			this.rotateIcon(item, 0, this.itemHeadingIconRotationDegree, false);
		}

		item.attr('data-active', true);
		this.$selectedItem = item;
	}

	deactivate(item) {
		item.children(`.${CLS}-dropdown-content`).slideUp({
			duration: this.itemContentAnimationDuration
		});
		this.rotateIcon(item, this.itemHeadingIconRotationDegree, 0);
		item.attr('data-active', false);
		this.$selectedItem = null;

		item.children(`.${CLS}-dropdown-content`).children(`.${CLS}-dropdown-content-inner`).children('[data-wg="SidebarItemsWidget"]').each((index, element) => {
			$(element).trigger(`${CLS}.dropdown.deactivate`, {});
		});
	}

	rotateIcon(item, initialDegree, degree, animate = true) {
		let $element = item.children(`.${CLS}-dropdown-heading`).children(`.${CLS}-dropdown-icon`);

		if(animate) {
			$({ deg: initialDegree }).animate({ deg: degree }, {
				duration: this.itemHeadingIconAnimationDuration,
				step: (now) => {
					$element.css({
						transform: `rotate(${now}deg)`
					});
				}
			});
		}
		else {
			$element.css({
				transform: `rotate(${degree}deg)`
			});
		}
	}
}
